module.exports = __webpack_public_path__ + "img/image-mt-1.9e1bc2cd.png";